<template>
<div :class="[bem('')]">
    <span :class="bem('login-text')" v-if="tips">{{tips}}</span>
    <Button
        :class="[bem('login-btn'), bem('hover')]"
        type="text"
        @click="vm.switchType('phone')">去登录</Button>
</div>

</template>
<script>
import _Button from "@gaoding/gdui/lib/button";
import bemMixin from '../bem';
export default {
  name: 'g-goto-login',
  components: {
    Button: _Button
  },
  mixins: [bemMixin],
  inject: ['vm'],
  props: {
    tips: {
      type: String,
      default: ''
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-goto-login {
  display: flex;
  font-family: PingFang SC;
  justify-content: center;
  align-content: center;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  margin-top: 20px;
}
.g-goto-login > span {
  line-height: 24px;
  text-align: center;
  color: #B4B8BF;
}
.g-goto-login > button {
  line-height: 22px;
  text-align: center;
  color: #2254F4;
}
.g-goto-login > button {
  line-height: 22px;
  text-align: center;
  color: #2254F4;
}
.g-goto-login__login-icon {
  color: #2254F4;
}
.g-goto-login:hover .g-goto-login__login-btn {
  font-weight: bold;
  color: #2254F4;
}

</style>
